export const MINIMUM_DATE = "1900-01-01";
export const STATION_API_BASE_URL = "https://127.0.0.1:3003/api/"; // This is the base URL for the station/hardware API.
export const MAX_PAGE_SIZE = 2147483646;
export const USER_CONTEXT_CUSTOM_HEADER = "x-user-context";
export const ORDER_MAX_QUANTITY = Number.MAX_SAFE_INTEGER;
